import React, { FC, useRef, useState } from 'react';
import { FilterChip } from '@silverfort/sf-components';
import { Popper } from '@material-ui/core';

import EntitiesSearch from '../../EntitiesSearch/EntitiesSearch';
import { Entity } from '../../../../api';

interface Props {
    onFilterSubmit: (mainEntities: Entity[]) => void;
}

const MainEntitiesSearch: FC<Props> = ({ onFilterSubmit }) => {
    const [mainEntities, setMainEntities] = useState<Entity[]>([]);
    const [searchEntitiesMenuOpen, setSearchEntitiesMenuOpen] = useState(false);

    const entitiesMenuAnchor = useRef<HTMLDivElement>(null);
    const [isDirty, setIsDirty] = useState(false);

    const onToggleEntitiesSearch = () => {
        if (isDirty) {
            onFilterSubmit(mainEntities);
        }

        setIsDirty(false);
        setSearchEntitiesMenuOpen((prev) => !prev);
    };

    return (
        <div>
            <div ref={entitiesMenuAnchor}>
                <FilterChip
                    text={
                        <span className="flex gap-1">
                            <span className="flex gap-0.5">
                                <span>Main Entities</span>:
                            </span>
                            <span className="font-medium">
                                {mainEntities?.length ? `${mainEntities.length} selected` : 'All'}
                            </span>
                        </span>
                    }
                    onClick={onToggleEntitiesSearch}
                />
            </div>
            <Popper
                open={searchEntitiesMenuOpen}
                anchorEl={entitiesMenuAnchor.current}
                disablePortal={true}
                placement={'bottom-start'}>
                <div className="w-[560px] h-[360px] bg-sf-white">
                    <EntitiesSearch
                        onClose={onToggleEntitiesSearch}
                        setSelectedEntities={setMainEntities}
                        selectedEntities={mainEntities}
                        setIsDirty={setIsDirty}
                    />
                </div>
            </Popper>
        </div>
    );
};

export default MainEntitiesSearch;
